import { GoogleAnalyticsService } from '@rightship-tech/common-ui/services/analytics/google-analytics.service';
import { Router } from 'aurelia-router';
import { autoinject } from "aurelia-dependency-injection";
import { type DocumentRequirementModel } from "../../../models/document-management.models";
import { bindable } from "aurelia-templating";
import { DocumentManagementRoutes } from '../../../constants/route.constant';
import { DialogClientService } from '@rightship-tech/common-ui/services/basic/dialog-client.service';
import { DocumentManagementDialogConstants } from '../../../constants/dialog.constants';
import { NotificationClientService, NotificationType } from '@rightship-tech/common-ui/services/basic/notification-client.service';
import { ConfigService } from '@rightship-tech/common-ui/services/basic/config.service';

//Load styles
require("./comp-document-requirement-card.scss");

@autoinject
export class CompDocumentRequirementCard {

    @bindable
    public noTotalVessels: number;

    @bindable
    public documentRequirement: DocumentRequirementModel;

    @bindable
    public canEdit: boolean;

    @bindable
    public isSubscribed?: boolean = null;

    @bindable
    public noSubscribedVessels: number;

    @bindable
    public onSave?: () => void = null;

    @bindable
    public isRsUser: boolean = false;

    @bindable
    public showCopyLink: boolean;

    constructor(private router: Router, private dialogClientService: DialogClientService, private googleAnalyticsService: GoogleAnalyticsService,
        private notificationClientService: NotificationClientService, private configService: ConfigService) { }

    //Edit a document requirement
    public editRequirement() {
        this.router.navigateToRoute(DocumentManagementRoutes.AddDocumentRequirements, 
            { documentRequirementId: this.documentRequirement.documentRequirementId, isEditing: true });
    }

    //Add to watchlist
    public addToWatchlist() {

		//Send event to google analytics
		this.googleAnalyticsService.sendCustomGA4EventMulti("dmc_watchlist_card_add_to_watchlist", {
            "charterer": this.documentRequirement.customerName
        });

        //Show dialog
        this.dialogClientService.show(DocumentManagementDialogConstants.ManageWatchlistDialog, { 
                documentRequirementId: this.documentRequirement.documentRequirementId,
                onSave: this.onSave
            }, true);
    }

    //Manage document requirement
    public manage() {
        this.dialogClientService.show(DocumentManagementDialogConstants.ManageWatchlistDialog, 
            { documentRequirementId:
                 this.documentRequirement.documentRequirementId, 
                isEditing: true,
                onSave: this.onSave 
            }, true);
    }

    //Copy link of document requirement
    public copyLink() {

        //Copy link to clipboard
        navigator.clipboard.writeText(this.configService.config.urls.myVesselsUrl + "/manage-document-requirements?dialog=manage-watchlist&documentRequirementId=" + this.documentRequirement.documentRequirementId);
        this.notificationClientService.show('Copied', `Document requirement link has been copied to your clipboard.`, NotificationType.Success);
    }
}